import { PurpleMark } from "./shared";

const ITEMS = [
    "More ways to be discovered",
    "More ideas worth trying",
    "More reasons for customers to return",
    "More time for the work you love",
];

export const Marquee = () => (
    <div className="mt-20 overflow-hidden border-y border-neutral-200 bg-white py-7" data-testid="editorial-marquee">
        <div className="animate-marquee-x flex w-max items-center whitespace-nowrap">
            {[...ITEMS, ...ITEMS].map((t, i) => (
                <span key={i} className="flex items-center font-display text-2xl font-bold tracking-[-0.02em] text-ink sm:text-3xl">
                    <span className="px-6">{t}</span>
                    <PurpleMark className="h-5 w-5 shrink-0 text-brand" />
                </span>
            ))}
        </div>
    </div>
);
